import PersonInfo from "../scenes/employee/components/PersonInfo";
import { selectEmployee } from "../scenes/employee/employeeSlice";
import { useSelector } from "react-redux";
import SalaryInfo from "../scenes/payroll/components/PayrollInfo";
import Incidents from "../scenes/incident/components/Incidents";
import Fuel from "../scenes/fuel/components/Fuel";

const BottomSection = () => {
  const employee = useSelector(selectEmployee);

  if (employee === null || employee === undefined) {
    return (<></>);
  }
  return (
    <section className="hr-bottom-section">
      <PersonInfo employee={employee} />
      <SalaryInfo employee={employee} />
      <div className="hr-additional-info">
        <Incidents employee={employee} />
        <Fuel employee={employee} />
      </div>
    </section>
  );
};

export default BottomSection;
